// @ts-ignore
window.REACT_APP_VERSION = process.env.REACT_APP_VERSION;
